/**
 * @generated SignedSource<<1289fa2888601107067e4b9a9a235fd9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CustomerDetailQuery$variables = {
  contractId: string;
};
export type CustomerDetailQuery$data = {
  readonly contract: {
    readonly id: string;
    readonly careReceiver: {
      readonly isSelfBooker: boolean;
      readonly name: {
        readonly firstName: string;
        readonly lastName: string;
      };
    };
    readonly " $fragmentSpreads": FragmentRefs<"CareReceiverDetails_contract" | "FirstCallActions_contract" | "IsNewCustomerCard_contract" | "StatusBarFirstAppointment_contract" | "FirstAppointmentChecklistButton_contract" | "FirstBookingActions_contract" | "ContractConfirmationActions_contract" | "AdditionalContactDetails_contract" | "StatusBarContractCancelation_contract" | "InsuranceDirectPaymentInfo_contract">;
  } | null;
};
export type CustomerDetailQuery = {
  variables: CustomerDetailQuery$variables;
  response: CustomerDetailQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contractId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "contractId",
    "variableName": "contractId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSelfBooker",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "Name",
  "kind": "LinkedField",
  "name": "name",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phoneNumber",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "durationInMinutes",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CustomerDetailQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Contract",
        "kind": "LinkedField",
        "name": "contract",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CareReceiver",
            "kind": "LinkedField",
            "name": "careReceiver",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CareReceiverDetails_contract"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "FirstCallActions_contract"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "IsNewCustomerCard_contract"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "StatusBarFirstAppointment_contract"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "FirstAppointmentChecklistButton_contract"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "FirstBookingActions_contract"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ContractConfirmationActions_contract"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AdditionalContactDetails_contract"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "StatusBarContractCancelation_contract"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "InsuranceDirectPaymentInfo_contract"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CustomerDetailQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Contract",
        "kind": "LinkedField",
        "name": "contract",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CareReceiver",
            "kind": "LinkedField",
            "name": "careReceiver",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "careDegree",
                "storageKey": null
              },
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Address",
                "kind": "LinkedField",
                "name": "address",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "city",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "street",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "houseNumber",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "postalCode",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "contractId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasFulfilledBooking",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ServiceRequest",
            "kind": "LinkedField",
            "name": "serviceRequest",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Schedule",
                "kind": "LinkedField",
                "name": "schedule",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "frequency",
                    "storageKey": null
                  },
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isFlexible",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isAllDay",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SubServiceDefinition",
                "kind": "LinkedField",
                "name": "subServices",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "label",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "subServiceId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ContractPricing",
            "kind": "LinkedField",
            "name": "pricing",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "grossCustomerPricePerHourInCents",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "grossCaregiverPricePerHourInCents",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "commissionRate",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cancelationScheduledFor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ServiceDocumentationConnection",
            "kind": "LinkedField",
            "name": "serviceDocumentation",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ServiceDocumentationEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ServiceDocumentation",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "month",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "year",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LastUploadedFile",
                        "kind": "LinkedField",
                        "name": "lastUploadedFile",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "filename",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "paymentMethod",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BookingConnection",
            "kind": "LinkedField",
            "name": "bookings",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BookingEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Booking",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "status",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BookingPricing",
                        "kind": "LinkedField",
                        "name": "pricing",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "grossPricePerHourInCents",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstBookingStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isNewCustomer",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Booking",
            "kind": "LinkedField",
            "name": "firstBooking",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endDate",
                "storageKey": null
              },
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "bookingId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isFirstBooking",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "firstBookingConfirmationStatus",
            "kind": "LinkedField",
            "name": "firstBookingConfirmationStatus",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "reason",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "confirmationStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Customer",
            "kind": "LinkedField",
            "name": "customer",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v5/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "82058bd6a02e0ded06c0a9438111df3d",
    "id": null,
    "metadata": {},
    "name": "CustomerDetailQuery",
    "operationKind": "query",
    "text": "query CustomerDetailQuery(\n  $contractId: ID!\n) {\n  contract(contractId: $contractId) {\n    id\n    careReceiver {\n      isSelfBooker\n      name {\n        firstName\n        lastName\n      }\n    }\n    ...CareReceiverDetails_contract\n    ...FirstCallActions_contract\n    ...IsNewCustomerCard_contract\n    ...StatusBarFirstAppointment_contract\n    ...FirstAppointmentChecklistButton_contract\n    ...FirstBookingActions_contract\n    ...ContractConfirmationActions_contract\n    ...AdditionalContactDetails_contract\n    ...StatusBarContractCancelation_contract\n    ...InsuranceDirectPaymentInfo_contract\n  }\n}\n\nfragment AdditionalContactDetails_contract on Contract {\n  customer {\n    phoneNumber\n    email\n    name {\n      firstName\n      lastName\n    }\n  }\n}\n\nfragment CareReceiverDetails_contract on Contract {\n  contractId\n  careReceiver {\n    email\n    careDegree\n    name {\n      firstName\n      lastName\n    }\n    phoneNumber\n    address {\n      city\n      street\n      houseNumber\n      postalCode\n    }\n    isSelfBooker\n  }\n  createdAt\n  hasFulfilledBooking\n  serviceRequest {\n    description\n    schedule {\n      frequency\n      durationInMinutes\n    }\n    subServices {\n      id\n      label\n      subServiceId\n    }\n  }\n  pricing {\n    grossCustomerPricePerHourInCents\n    grossCaregiverPricePerHourInCents\n    commissionRate\n  }\n  cancelationScheduledFor\n  serviceDocumentation {\n    edges {\n      node {\n        month\n        year\n        lastUploadedFile {\n          filename\n        }\n        id\n      }\n    }\n  }\n  paymentMethod\n  bookings {\n    edges {\n      node {\n        id\n        status\n        pricing {\n          durationInMinutes\n          grossPricePerHourInCents\n        }\n      }\n    }\n  }\n}\n\nfragment ContractConfirmationActions_contract on Contract {\n  confirmationStatus\n  contractId\n  firstBookingStatus\n  firstBooking {\n    endDate\n    id\n  }\n  bookings {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n}\n\nfragment FirstAppointmentChecklistButton_contract on Contract {\n  contractId\n  firstBookingStatus\n  hasFulfilledBooking\n  firstBooking {\n    endDate\n    id\n  }\n}\n\nfragment FirstBookingActions_contract on Contract {\n  contractId\n  hasFulfilledBooking\n  firstBookingStatus\n  firstBookingConfirmationStatus {\n    description\n    reason\n  }\n  firstBooking {\n    bookingId\n    startDate\n    endDate\n    isFirstBooking\n    id\n  }\n  serviceRequest {\n    schedule {\n      durationInMinutes\n      isFlexible\n      isAllDay\n    }\n  }\n}\n\nfragment FirstCallActions_contract on Contract {\n  contractId\n  firstBookingStatus\n  hasFulfilledBooking\n  careReceiver {\n    phoneNumber\n  }\n}\n\nfragment InsuranceDirectPaymentInfo_contract on Contract {\n  contractId\n  paymentMethod\n}\n\nfragment IsNewCustomerCard_contract on Contract {\n  firstBookingStatus\n  hasFulfilledBooking\n  isNewCustomer\n}\n\nfragment StatusBarContractCancelation_contract on Contract {\n  cancelationScheduledFor\n}\n\nfragment StatusBarFirstAppointment_contract on Contract {\n  hasFulfilledBooking\n  firstBookingStatus\n  firstBooking {\n    endDate\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "c78605b624a4a161ad20d6be42d85d40";

export default node;
